export default {
  VALIDATED: "Validated",
  UNDER_REVIEW: "UnderReview",
};
